import React from 'react'
import { styled } from '../../assets/theme';
import Ticker from './QuoteItem/Ticker';

interface IStockInfo {
  key: string,
  label: string,
  yield?: string
}

const stocks: IStockInfo[] = [
  {
    key: 'ES',
    label: 'ES',
  },
  /*{
    key: 'SPX',
    label: 'SPX',
  },*/
  {
    key: 'NQ',
    label: 'NQ',
  }/*,
  {
    key: 'NDX',
    label: 'NDX',
  },
  {
    key: 'COMP',
    label: 'COMP',
  },
  {
    key: 'DJI',
    label: 'DJI',
  },
  {
    key: 'TICK-NYSE',
    label: 'TICK.N',
  },
  {
    key: 'ZN',
    label: 'ZN',
    yield: 'US10YT',
  },
  {
    key: 'ZB',
    label: 'ZB',
    yield: 'US30YT',
  },
  {
    key: 'CL',
    label: 'CL',
  },
  {
    key: 'BTC',
    label: 'BTC',
  },
  {
    key: 'VXXB',
    label: 'VXXB',
  },
  {
    key: 'VIX',
    label: 'VIX',
  },
  {
    key: 'VX1',
    label: 'VX1',
  },
  {
    key: 'VX2',
    label: 'VX2',
  },*/
];

const verticalStocks: IStockInfo[] = [];

export const Quotes: React.FunctionComponent<{id: number, match: string}> = ({ match, id }) => (

  <QuotesContainer>
    {stocks.map(stock => (
      <Ticker flow="row" id={id} key={stock.key} label={stock.label} symbol={stock.key} yieldSymbol={stock.yield} />
    ))}
    <div style={{ gridColumn: 'span 3' }}>
      {verticalStocks.map(stock => (
        <Ticker flow="column" id={id} key={stock.key} label={stock.label} symbol={stock.key} yieldSymbol={stock.yield} />
      ))}
    </div>
  </QuotesContainer>
);

const QuotesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  grid-template-columns: repeat(auto-fit, 100px);
`;

export default Quotes;
